// eslint-disable-next-line import/prefer-default-export
export const RECORD_FETCH = 'RECORD_FETCH';
export const RESET_RECORD = 'RESET_RECORD';
export const RESET_FORM_EVENT = 'RESET_FORM_EVENT';
